import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Input,
  Label,
  RadioGroup,
  RadioGroupItem,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { useState } from "react";
import { toast } from "sonner";

export default function Booking() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    time: "",
    type: "Group Class",
  });

  return (
    <div className="max-w-4xl mx-auto px-6 py-12 space-y-10">
      <header className="space-y-3">
        <h1 className="text-4xl font-bold" style={{ fontFamily: "var(--font-display)" }}>
          Flower Arrangement Courses
        </h1>
        <p className="text-muted-foreground">Learn with our teachers in a cozy, retro space.</p>
      </header>

      <div className="grid md:grid-cols-2 gap-8">
        <Card>
          <CardHeader>
            <CardTitle>Register</CardTitle>
            <CardDescription>Pick a time slot and leave your details.</CardDescription>
          </CardHeader>
          <CardContent className="grid gap-4">
            <div className="grid gap-2">
              <Label htmlFor="name">Full Name</Label>
              <Input
                id="name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="phone">Phone Number</Label>
              <Input
                id="phone"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>

            <div className="grid gap-2">
              <Label>Preferred Time</Label>
              <RadioGroup
                value={form.time}
                onValueChange={(v) => setForm({ ...form, time: v })}
                className="grid grid-cols-1 gap-2"
              >
                {[
                  { id: "am", label: "10:00–14:00" },
                  { id: "pm", label: "15:00–18:00" },
                ].map((t) => (
                  <div key={t.id} className="flex items-center gap-2 rounded-lg border px-3 py-2">
                    <RadioGroupItem id={`t-${t.id}`} value={t.label} />
                    <Label htmlFor={`t-${t.id}`}>{t.label}</Label>
                  </div>
                ))}
              </RadioGroup>
            </div>

            <div className="grid gap-2">
              <Label>Class Type</Label>
              <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
                <SelectTrigger>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="Private Class">Private Class — 5,999 THB</SelectItem>
                  <SelectItem value="Group Class">Group Class — 3,999 THB</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <Button
              onClick={async () => {
                if (!form.name || !form.phone || !form.email || !form.time)
                  return toast.error("Please complete the form");
                const res = await fetch("/api/booking", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(form),
                });
                if (res.ok)
                  toast.success(`Booked ${form.type} at ${form.time}. We will email details soon!`);
                else toast.error("Failed to submit booking");
              }}
            >
              Register
            </Button>
          </CardContent>
        </Card>

        <div className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Pricing</CardTitle>
            </CardHeader>
            <CardContent className="text-sm grid gap-2">
              <p>
                <span className="font-medium">Private Class:</span> 5,999 THB
              </p>
              <p>
                <span className="font-medium">Group Class:</span> 3,999 THB
              </p>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Teachers</CardTitle>
            </CardHeader>
            <CardContent className="text-sm grid gap-1">
              <p>Teacher Cha</p>
              <p>Teacher Oum</p>
              <p>Teacher Nan</p>
              <p>Teacher Khanchit</p>
            </CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>What you’ll learn</CardTitle>
            </CardHeader>
            <CardContent className="text-sm text-muted-foreground">
              Classic bouquet balance, color pairing with bold primaries, and wrapping techniques
              with retro finesse.
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
